export var FeedbackMode;
(function (FeedbackMode) {
    FeedbackMode["None"] = "NONE";
    FeedbackMode["Positive"] = "POSITIVE";
    FeedbackMode["Negative"] = "NEGATIVE";
    FeedbackMode["Sent"] = "SENT";
})(FeedbackMode || (FeedbackMode = {}));
